import store from '../store/Store';

export default function getConversationSubject(): string {
    if (!!store.conversationReadingPaneViewState) {
        return store.conversationReadingPaneViewState.conversationSubject;
    } else {
        return null;
    }
}
